interface IProductTransparentPricing {
  readonly title: string
  readonly subTitle: string
  readonly items: TransparentPricingItem[]
}

export default class ProductTransparentPricing implements IProductTransparentPricing {
  readonly title: string
  readonly subTitle: string
  readonly items: TransparentPricingItem[]

  constructor({ title, subTitle, items }: IProductTransparentPricing) {
    this.title = title
    this.subTitle = subTitle
    this.items = items
    return {
      ...this,
    }
  }
}

interface ITransparentPricingItem {
  readonly crafting: number
  readonly creditCardFees: number
  readonly hardware: number
  readonly lastBrandFindersFee: number
  readonly materials: number
  readonly name: string
  readonly packaging: number
  readonly shippingHandling: number
  readonly svid: number
  readonly variantId: number
  readonly totalPrice: number
  readonly sockDonationCost?: number
  readonly dutyFee?: number
}

export class TransparentPricingItem implements ITransparentPricingItem {
  readonly crafting: number
  readonly creditCardFees: number
  readonly hardware: number
  readonly lastBrandFindersFee: number
  readonly materials: number
  readonly name: string
  readonly packaging: number
  readonly shippingHandling: number
  readonly svid: number
  readonly variantId: number
  readonly totalPrice: number
  readonly sockDonationCost?: number
  readonly dutyFee?: number
  constructor({
    crafting,
    creditCardFees,
    hardware,
    lastBrandFindersFee,
    materials,
    name,
    packaging,
    shippingHandling,
    svid,
    variantId,
    totalPrice,
    sockDonationCost,
    dutyFee,
  }: ITransparentPricingItem) {
    this.crafting = crafting
    this.creditCardFees = creditCardFees
    this.hardware = hardware
    this.lastBrandFindersFee = lastBrandFindersFee
    this.materials = materials
    this.name = name
    this.packaging = packaging
    this.shippingHandling = shippingHandling
    this.svid = svid
    this.variantId = variantId
    this.totalPrice = totalPrice
    this.sockDonationCost = sockDonationCost
    this.dutyFee = dutyFee
    return {
      ...this,
    }
  }
}
